import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ReactComponent as VisibilityIcon } from "../assets/icons/visibility.svg";
import { colors } from "../values/colors";

// ⭐ Import RTK Query hook (global role cache)
import { useGetAllRolesQuery } from "../services/auctionAPI";

const PlayerCard = ({
  name,
  role,
  image,
  purchasedAt,
  onView,
  showActions = false,
  showPurchase = false,
  onClick,
  bidPrice,
  teamLogo,
  isCaptain,
  isIconPlayer,
}) => {
  // ⭐ Get cached roles from RTK Query
  const { data: playerRoles } = useGetAllRolesQuery();

  // ⭐ Find matching roleName (same as Redux version)
  const roleObj = playerRoles?.data?.find((item) => item?._id === role);

  const roleName = roleObj?.name || "—";

  return (
    <Box
      sx={{
        borderRadius: 3,
        boxShadow: "0px 1px 3px 1px #00000026, 0px 1px 2px 0px #0000004D",
        overflow: "hidden",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        backgroundColor: "#fff",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0px 2px 6px 2px #00000026, 0px 2px 4px 0px #0000004D",
        },
        width: "100%",
        maxWidth: 330,
        height: "-webkit-fill-available",
      }}
      onClick={onClick}
    >
      {/* Image */}
      <Box
        component="img"
        src={image}
        alt={name}
        sx={{
          width: "100%",
          aspectRatio: "1 / 1",
          objectFit: "cover",
        }}
      />

      {/* Content */}
      <Box sx={{ p: 2, position: "relative" }}>
        {teamLogo && (
          <Box
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              width: "4rem",
              height: "4rem",
            }}
          >
            <img src={teamLogo} alt="logo" width={"100%"} height={"100%"} />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* Left side */}
          <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <Typography
              noWrap
              sx={{
                background: colors.primary,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 500,
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {name}
              {isCaptain ? (
                <Typography sx={{ mt: ".3rem", ml: ".2rem" }}>(C)</Typography>
              ) : (
                ""
              )}{" "}
              {isIconPlayer ? (
                <Typography sx={{ mt: ".3rem", ml: ".2rem" }}>(R)</Typography>
              ) : (
                ""
              )}
            </Typography>

            <Typography
              noWrap
              sx={{
                color: colors.secondary,
                fontSize: "20px",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {roleName}
            </Typography>
            {bidPrice !== null && bidPrice !== undefined && (
              <Typography
                sx={{
                  fontSize: "20px",
                  mt: 0.4,
                  fontWeight: 500,
                  color: "#333",
                  display: "flex",
                }}
              >
                B.Price: {bidPrice} Pts
              </Typography>
            )}

            {showPurchase &&
              purchasedAt !== null &&
              purchasedAt !== undefined && (
                <Typography
                  sx={{
                    fontSize: "20px",
                    mt: 0.4,
                    fontWeight: 500,
                    color: "#333",
                    display: "flex",
                  }}
                >
                  Purchased At:
                  <Typography
                    sx={{
                      background: colors.primary,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "20px",
                      fontWeight: 500,
                      ml: 0.5,
                    }}
                  >
                    {purchasedAt} Pts
                  </Typography>
                </Typography>
              )}
          </Box>

          {/* Action Icons */}
          {showActions && (
            <Box sx={{ display: "flex", gap: 0.5 }}>
              <IconButton size="small" onClick={onView}>
                <VisibilityIcon />
              </IconButton>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PlayerCard;
